import React from 'react';
import {ErrorBoundary} from "react-error-boundary";

function ErrorBoundaryWrapper(props) {
    return (
        <><ErrorBoundary fallback={<>Something Went Wrong</>}>{props.children}</ErrorBoundary></>
    );
}

export default ErrorBoundaryWrapper;